<!-- Left -->
<div class="col">
  <!-- Number -->
  <p class="mb-2">
    <b>{{ 'document-view-public.document-view-dates.number' | translate }}:</b>
  </p>

  <!-- Date -->
  <p class="mb-2">{{ 'document-view-public.document-view-dates.date' | translate }}:</p>

  <!-- Date service -->
  <p class="mb-2">
    <span *ngIf="!!doc.dateServiceTo"
      >{{ 'document-view-public.document-view-dates.period-of-service' | translate }}:</span
    >
    <span
      *ngIf="
        !doc.dateServiceTo && !!doc.dateService
      "
      >{{ 'document-view-public.document-view-dates.date-of-service' | translate }}:</span
    >
  </p>

  <!-- Date service to -->
  <p class="mb-2" *ngIf="doc.dateServiceTo">
    {{ 'document-view-public.document-view-dates.date-of-service-to' | translate }}:
  </p>

  <!-- Date Two -->
  <p
    class="mb-2"
    *ngIf="
      doc.dateDue ||
      doc.dateValidTill ||
      doc.datePaid
    "
  >
    <b *ngIf="doc.type === 'invoice'"
      >{{ 'document-view-public.document-view-dates.date-payment-due' | translate }}:</b
    >
    <span *ngIf="doc.type === 'estimate'"
      >{{ 'document-view-public.document-view-dates.valid-till' | translate }}:</span
    >
    <span *ngIf="doc.type === 'advance'"
      >{{ 'document-view-public.document-view-dates.date-of-payment' | translate }}:</span
    >
  </p>

  <!-- Reference -->
  <p class="mb-2" *ngIf="doc.reference">
    {{ 'document-view-public.document-view-dates.reference' | translate }}:
  </p>
</div>

<!-- Right -->
<div class="col col-sm-auto text-right">
  <!-- Number -->
  <p class="mb-2">
    <b *ngIf="doc.number">{{ doc.number }}</b>
    <b *ngIf="!doc.number">{{ 'document-view-public.document-view-dates.draft' | translate }}</b>
  </p>

  <!-- Date -->
  <p class="mb-2">
    {{ doc.date | pepDate: locale }}
  </p>

  <!-- Date service -->
  <p class="mb-2">
    {{ doc.dateService | pepDate: locale }}
  </p>

  <!-- Date service to -->
  <p class="mb-2" *ngIf="doc.dateServiceTo">
    {{ doc.dateServiceTo | pepDate: locale }}
  </p>

  <!-- Date Two -->
  <!-- TODO: More similar to doc add implementation -->
  <p
    class="mb-2"
    *ngIf="
      doc.dateDue ||
      doc.dateValidTill ||
      doc.datePaid
    "
  >
    <b *ngIf="doc.type === 'invoice'">{{
      doc.dateDue | pepDate: locale
    }}</b>
    <span *ngIf="doc.type === 'estimate'">{{
      doc.dateValidTill | pepDate: locale
    }}</span>
    <span *ngIf="doc.type === 'advance'">{{
      doc.datePaid | pepDate: locale
    }}</span>
  </p>

  <!-- Reference -->
  <p class="mb-2" *ngIf="doc.reference">
    {{ doc.reference }}
  </p>
</div>
